import { Component, OnInit, Input, OnChanges } from '@angular/core';
// import { ProductService } from "../../services/product.service";
import { AuthService } from '../../../services/auth.service';
import { Product } from '../../../models/Product';
import { User } from '../../../models/User';
import { Observable} from 'rxjs';

@Component({
  selector: 'app-product-card',
  templateUrl: './product-card.component.html',
  styleUrls: ['./product-card.component.scss']
})
export class ProductCardComponent implements OnInit, OnChanges {
  @Input('product') product: Product;
  @Input('user') user:User;  //needed to toggle the edit button for admin users that are logged in.
  @Input('price') price: number;  //needed so that we can observe changes in price value and recalc total for view in product-card-edit's splitview.
  //  *alternatively could have made product a behaviorSubject and observed changes in it via '.next' and '.subscribe'
  glutenFreeOption: boolean = false;
  veganOption: boolean = false;
  totalPrice:number = 0
  productdate?: Date;  //store properly formatted date

  constructor(private authService:AuthService) { }

  ngOnInit() {
    // console.log('product-card has item: ', this.product);
    // this.updatePriceTotal();

  }

  ngOnChanges(){
    // console.log('pc - price:', this.product.product_price);
    this.updatePriceTotal();
    this.productdate = new Date(this.product.updated_at);  //convert timestamp to Date
  }

  clickedGlutenFree($event){
    let button = $event.target;
    button.blur();  //remove focus
    this.glutenFreeOption = !this.glutenFreeOption;
    this.updatePriceTotal();
  }

  clickedVegan($event){
    let button = $event.target;
    button.blur();
    this.veganOption = !this.veganOption;
    this.updatePriceTotal();
  }

  updatePriceTotal(){
    let originalPrice = this.product.product_price;
    let glutenFreePrice = this.glutenFreeOption ? 5 : 0;
    let veganPrice = this.veganOption ? 5 : 0;
    let totalPrice = originalPrice + glutenFreePrice + veganPrice;
    this.totalPrice = totalPrice;
    // console.log(totalPrice);
  }

}



// WEBPACK FOOTER //
// ./src/app/components/products/product-card/product-card.component.ts